import { render, staticRenderFns } from "./phoneBooksList.vue?vue&type=template&id=1706ffdc&scoped=true&"
import script from "./phoneBooksList.vue?vue&type=script&lang=js&"
export * from "./phoneBooksList.vue?vue&type=script&lang=js&"
import style0 from "./phoneBooksList.vue?vue&type=style&index=0&id=1706ffdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1706ffdc",
  null
  
)

export default component.exports